import { Field, Formik, FormikHelpers } from 'formik'

import Box from '@totallymoney/ui/components/Box'
import Button from '@totallymoney/ui/components/Button'
import ValidationMessage from '@totallymoney/ui/components/Field/ValidationMessage'
import Flex from '@totallymoney/ui/components/Flex'
import Stack from '@totallymoney/ui/components/Stack'

import { LoanTableFilterFormValues } from '@appTypes/App.interface'

import FormikTextField from '@components/form/FormikTextField'

import formatNumberToCurrency from '@utils/formatNumberToCurrency'
import { LoanFilterLimits } from '@utils/getCategoryLoanFilterLimits'

import FormikLoanPurposeSelect from './components/FormikLoanPurposeSelect'
import FormikLoanTermSelect from './components/FormikLoanTermSelect'

interface LoansTableFilterFormProps {
    formValues: LoanTableFilterFormValues
    loanFilterLimits: LoanFilterLimits
    onCloseModal: () => void
    onFormSubmit: (
        formValues: LoanTableFilterFormValues,
        formikHelpers: FormikHelpers<LoanTableFilterFormValues>
    ) => void
    showLoanPurpose?: boolean
    validationSchema: any
}

const LoansTableFilterForm = ({
    formValues,
    loanFilterLimits,
    onCloseModal,
    onFormSubmit,
    showLoanPurpose,
    validationSchema,
}: LoansTableFilterFormProps) => (
    <Formik
        initialValues={formValues}
        onSubmit={onFormSubmit}
        validate={validationSchema}
        validateOnBlur={true}
        validateOnChange={false}
    >
        {({ submitForm, isSubmitting, setFieldValue, status }) => (
            <>
                <Box mb="space20" />

                <Stack
                    width="100%"
                    space="space40"
                    maxWidth="422px"
                    margin="auto"
                >
                    <Field
                        name="loanAmount"
                        labelText="How much would you like to borrow?"
                        helperText={`${formatNumberToCurrency(loanFilterLimits.loanAmount.min)} - ${formatNumberToCurrency(loanFilterLimits.loanAmount.max)}`}
                        component={FormikTextField}
                        prefix="£"
                        type="number"
                        onFocus={() => setFieldValue('loanAmount', '')}
                    />

                    <FormikLoanTermSelect />

                    {showLoanPurpose ? <FormikLoanPurposeSelect /> : null}

                    <Stack space="space20" justifyContent="center">
                        <Button
                            variant="primary"
                            text="Update results"
                            type="submit"
                            loading={isSubmitting}
                            onClick={submitForm}
                        />

                        {status ? (
                            <ValidationMessage
                                variant="error"
                                id="loans-table-filter-form-error"
                                message="Something went wrong while submitting the form, please try again."
                            />
                        ) : null}

                        <Button
                            onClick={onCloseModal}
                            variant="secondaryOutline"
                            text="Cancel"
                        />
                    </Stack>
                </Stack>
            </>
        )}
    </Formik>
)

export default LoansTableFilterForm
